export default __webpack_public_path__ + "static/omar_smiling-3ac82b400044145286b3b1b994ec2f9c.png";